import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
import DiagnosticFields from '../not-donor/diagnostic-fields';

export default <template>
  <div class='field'>
    <@form.Dropdown
      @propertyName='mrcStage'
      @labelName='Stade'
      @translationKey='fur.mrc-stage'
      @isMandatory={{true}}
      as |dropdown|
    >
      <dropdown.Item @key='stage-undefined' />
      <dropdown.Item @key='stage-1' />
      <dropdown.Item @key='stage-2' />
      <dropdown.Item @key='stage-3' />
      <dropdown.Item @key='stage-3-a' />
      <dropdown.Item @key='stage-3-b' />
      <dropdown.Item @key='stage-4' />
      <dropdown.Item @key='stage-5' />
    </@form.Dropdown>
  </div>

  <div class='field'>
    <@form.BasicRadioGroup
      @title='Greffe pré existante'
      @propertyName='mrcPreexistingTransplant'
      @errorClass='left-aligned-validation-error-message'
      as |Group|
    >
      <div class='fields'>
        <div class='field'>
          <Group.Radio @label='Oui' @value={{true}} />
        </div>
        <div class='field'>
          <Group.Radio @label='Non' @value={{false}} />
        </div>
        <div class='field'>
          <Group.Radio @label='Non renseigné' @value='' />
        </div>
      </div>
    </@form.BasicRadioGroup>
  </div>

  <DiagnosticFields @form={{@form}} />
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
